export const INFO = 'Add to home screen';
export const IMAGE_LOGO =
  'https://images-static.nykaa.com/nykdesignstudio-images/pub/media/brand_logo_white.svg';

export const A2HS_KEY = 'A2HS_ALREADY_SHOWN';

export const DELAY_TO_AVOID_JERK = 4000;

export const SESSION_TIME_AFTER_CANCEL = 432000000; // 5 days
